import { render } from "./UserAddressAdd.vue?vue&type=template&id=2c57593c&scoped=true"
import script from "./UserAddressAdd.vue?vue&type=script&lang=js"
export * from "./UserAddressAdd.vue?vue&type=script&lang=js"

import "./UserAddressAdd.vue?vue&type=style&index=0&id=2c57593c&scoped=true&lang=css"

import exportComponent from "E:\\zzh\\zl-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c57593c"]])

export default __exports__